module.exports = __webpack_public_path__ + "img/headBg3.6bee18df.png";